import axios from 'axios';
import { i18n } from '@/i18n/index.js';

const envBaseUrl = (import.meta.env.VITE_API_BASE_URL || '').trim();
const normalizedBaseUrl = envBaseUrl.replace(/\/+$/, '');

function resolveApiBaseUrl() {
  if (typeof window !== 'undefined') {
    const host = String(window.location.hostname || '').toLowerCase();

    // On tenant domains prefer explicit env base URL when configured,
    // otherwise fall back to same-origin proxy.
    if (host.endsWith('.taskroot-erp.de')) {
      return normalizedBaseUrl || '/api';
    }
  }

  return normalizedBaseUrl || '/api';
}

const api = axios.create({
  baseURL: resolveApiBaseUrl(),
  timeout: 10000,
});

// Response interceptor – 401 → Logout
// Login-Endpoint ausschließen (gibt selbst 401 bei falschen Daten zurück)
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || '';
    const isLoginRequest = url.includes('/auth/login');
    const isSetLanguageRequest = url.includes('/auth/set-language');
    const isTenantResolveRequest = url.includes('/auth/resolve-tenant-by-domain');

    if (err.response?.data?.code === 'TRIAL_LIMIT_EXCEEDED') {
      const { entity, current, limit } = err.response.data;
      const t = i18n.global.t;
      const entityLabel = t(`common.trialEntities.${entity}`, entity);
      alert(t('common.trialLimitExceeded', { current, limit, entity: entityLabel }));
    }

    if (err.response?.status === 401 && !isLoginRequest && !isSetLanguageRequest && !isTenantResolveRequest) {
      try {
        sessionStorage.setItem('last-auth-401-url', url);
        sessionStorage.setItem('last-auth-401-status', String(err.response?.status || ''));
      } catch {}

      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // Sofort weiterleiten – kein Delay.
      // window.location.replace() verhindert zusätzlich, dass der User
      // per Zurück-Button auf die defekte Seite zurückkommt.
      if (window.location.pathname !== '/login') {
        window.location.replace('/login');
      }
    }
    return Promise.reject(err);
  }
);

export default api;